export const commonDataGridStyles = (colors) => {
  return {
    "& .MuiDataGrid-root": {
      border: "none",
      backgroundColor: colors.primary[700],
    },
    "& .MuiDataGrid-cell": {
      borderBottom: `1px solid ${colors.grey[900]}`,
      color: colors.grey[700],
      fontSize: 12,
      fontWeight: 500,
    },
    // MUI's default keyboard-focus outline fires on every mouse click too;
    // this app has no cell-level keyboard navigation UX, so drop it rather
    // than show a blue focus square on click.
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
      {
        outline: "none",
      },
    "& .name-column--cell": {
      color: colors.blue[500],
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: colors.primary[600],
      borderBottom: `1px solid ${colors.grey[800]}`,
      color: colors.grey[500],
      //   textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 500,
      //   letterSpacing: "0.06em",
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      backgroundColor: colors.primary[700],
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: colors.primary[600],
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: `1px solid ${colors.grey[800]}`,
      backgroundColor: colors.primary[700],
    },
    "& .MuiCheckbox-root": {
      color: `${colors.blue[500]} !important`,
    },
  };
};

export const dataGridFooterStatusStyles = (color) => {
  return {
    typography: "h5",
    m: "3px",
    borderRadius: 1,
    bgcolor: color,
    padding: "2px",
    paddingX: "4px",
    fontWeight: 600,
  };
};

export const dataGridButtonTypography = (colors, fontWeight = 500) => ({
  color: "#fff",
  fontWeight: fontWeight,
  fontSize: 11,
});
